import { render, staticRenderFns } from "./detailGD.vue?vue&type=template&id=0ffc7f72&scoped=true"
import script from "./detailGD.vue?vue&type=script&lang=js"
export * from "./detailGD.vue?vue&type=script&lang=js"
import style0 from "./detailGD.vue?vue&type=style&index=0&id=0ffc7f72&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffc7f72",
  null
  
)

export default component.exports